import { render, staticRenderFns } from "./success-sign-up.vue?vue&type=template&id=019d6956&scoped=true"
import script from "./success-sign-up.vue?vue&type=script&lang=js"
export * from "./success-sign-up.vue?vue&type=script&lang=js"
import style0 from "./success-sign-up.vue?vue&type=style&index=0&id=019d6956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d6956",
  null
  
)

export default component.exports